import { makeStyles } from '../../../styles';
export const useWizardNavigationSectionStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    customBtn: {
        marginRight: '8px',
    },
}));
//# sourceMappingURL=WizardNavigationSections.styles.js.map